/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Card, Table, Tag, Tooltip, Breadcrumb, message, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined, EditOutlined, LockOutlined } from '@ant-design/icons';
import { getAllEmailTemplates, getEmailTemplateVariables } from '../../redux/emailTemplateSlice';
import DrawerEmailTemplate from './DrawerEmailTemplate';
import TRIGGER_KEYS from './emailTemplateConstants';
import { style } from '../../Styles';

const triggerKeyLabel = (key) => TRIGGER_KEYS.find((t) => t.value === key)?.label || key;

const EmailTemplates = () => {
	const dispatch = useDispatch();
	const { Brand } = useSelector((state) => state.brand);
	const { emailTemplates } = useSelector((state) => state.emailTemplates);

	const [drawerOpen, setDrawerOpen] = useState(false);
	const [selectedTemplateId, setSelectedTemplateId] = useState(null);
	const [search, setSearch] = useState('');

	const fetchTemplates = () => {
		dispatch(getAllEmailTemplates())
			.unwrap()
			.catch(() => message.error('Failed to load email templates'));
	};

	useEffect(() => {
		fetchTemplates();
		dispatch(getEmailTemplateVariables());
	}, []);

	const openCreate = () => {
		setSelectedTemplateId(null);
		setDrawerOpen(true);
	};

	const openEdit = (id) => {
		setSelectedTemplateId(id);
		setDrawerOpen(true);
	};

	const closeDrawer = () => {
		setDrawerOpen(false);
		setSelectedTemplateId(null);
		fetchTemplates();
	};

	const filtered = (emailTemplates.list || []).filter((t) => {
		if (!search) return true;
		const q = search.toLowerCase();
		return (
			t.templateName?.toLowerCase().includes(q) ||
			t.subject?.toLowerCase().includes(q) ||
			t.triggerKey?.toLowerCase().includes(q)
		);
	});

	const columns = [
		{
			title: 'Template Name',
			dataIndex: 'templateName',
			key: 'templateName',
			render: (name) => <strong>{name}</strong>,
		},
		{
			title: 'Trigger Key',
			dataIndex: 'triggerKey',
			key: 'triggerKey',
			render: (key) =>
				key ? (
					<Tag icon={<LockOutlined />} color='blue'>
						{triggerKeyLabel(key)}
					</Tag>
				) : (
					<Tag color='default'>Manual only</Tag>
				),
		},
		{
			title: 'Subject',
			dataIndex: 'subject',
			key: 'subject',
			ellipsis: { showTitle: true },
			width: 240,
		},
		{
			title: 'Actions',
			key: 'actions',
			width: 80,
			render: (_, record) => (
				<Tooltip title='Edit'>
					<Button
						type='text'
						icon={<EditOutlined />}
						onClick={() => openEdit(record.id)}
					/>
				</Tooltip>
			),
		},
	];

	return (
		<>
			<Breadcrumb
				style={style.breadcrumb}
				items={[{ title: 'Settings' }, { title: 'Email Templates' }]}
			/>
			<Card style={style.card}>
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 8 }}>
					<Input.Search
						placeholder='Search templates...'
						allowClear
						style={{ width: 300 }}
						onChange={(e) => setSearch(e.target.value)}
					/>
					<div style={{ display: 'flex', gap: 8 }}>
						<Button icon={<ReloadOutlined />} onClick={fetchTemplates} />
						<Button type='primary' onClick={openCreate}>
							Add Template
						</Button>
					</div>
				</div>
				<Table
					rowKey='id'
					columns={columns}
					dataSource={filtered}
					loading={emailTemplates.loading}
					pagination={{ pageSize: 10, showSizeChanger: true }}
				/>
			</Card>
			{drawerOpen && (
				<DrawerEmailTemplate
					templateId={selectedTemplateId}
					onClose={closeDrawer}
					brandPrimary={Brand?.brandData?.webPrimary}
				/>
			)}
		</>
	);
};

export default EmailTemplates;
